import { useEffect, useState } from "react";
import Header from "../Home/Header";
import Footer from "../Footer/Footer";
import "../css/flaticon.min.css";
import "../css/fontawesome-5.14.0.min.css";
import "../Main.css";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";
import emailjs from "@emailjs/browser";
import {
  EMAILJS_SERVICE_ID,
  EMAILJS_CONTACT_TEMPLATE_ID,
  EMAILJS_AUTOREPLY_TEMPLATE_ID,
  EMAILJS_PUBLIC_KEY,
} from "../emailjsConfig";
import { useTranslation } from "react-i18next";

const SoftwareDevelop = () => {
  const [data, setData] = useState({
    name: "",
    mail: "",
    phonenumber: "",
    subject: "",
    message: "",
  });

  const handleContact = async (e: any) => {
    e.preventDefault();
    try {
      const contactParams = {
        name: data.name,
        mail: data.mail,
        from_email: data.mail,
        phonenumber: data.phonenumber,
        subject: data.subject,
        address: "",
        message: data.message,
      };
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_CONTACT_TEMPLATE_ID,
        contactParams,
        { publicKey: EMAILJS_PUBLIC_KEY }
      );
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_AUTOREPLY_TEMPLATE_ID,
        contactParams,
        { publicKey: EMAILJS_PUBLIC_KEY }
      );
      setData({
        name: "",
        mail: "",
        phonenumber: "",
        subject: "",
        message: "",
      });
      alert("Mail Send Successfuly");
    } catch (err: any) {
      console.log(err.message);
      alert("Got internal error");
    }
  };

  const { t } = useTranslation()

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [demoData, setDemoData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    service: "",
    message: "",
  });
  const [isDemoSubmitting, setIsDemoSubmitting] = useState(false);

  const handleBookDemo = async () => {
    try {
      setIsDemoSubmitting(true);
      const demoParams = {
        name: `${demoData.firstName} ${demoData.lastName}`.trim(),
        mail: demoData.email,
        from_email: demoData.email,
        phonenumber: demoData.phone,
        subject: `Book a Demo - ${demoData.service}`,
        address: "",
        message: demoData.message,
      };
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_CONTACT_TEMPLATE_ID,
        demoParams,
        { publicKey: EMAILJS_PUBLIC_KEY }
      );
      await emailjs.send(
        EMAILJS_SERVICE_ID,
        EMAILJS_AUTOREPLY_TEMPLATE_ID,
        demoParams,
        { publicKey: EMAILJS_PUBLIC_KEY }
      );
      setDemoData({
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        service: "",
        message: "",
      });
      setIsModalOpen(false);
      alert("Your demo request has been sent. We'll reach out soon!");
    } catch (err) {
      alert("Something went wrong. Please try again.");
    } finally {
      setIsDemoSubmitting(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Best Software Development Company in Chennai - The Tech Horse</title>
        <meta
          name="description"
          content="Looking for a top software development company in Chennai? We build custom, scalable software solutions for businesses. Contact us for a free quote!"
        />
      </Helmet>
      <Header />

      <section className="page-banner-area software-bg pt-245 rpt-150 pb-170 rpb-100 rel z-1 bgc-lighter text-center">
        <div className="container">
          <div className="banner-inner rpt-10">
            <h1 className="page-title wow fadeInUp delay-0-2s">
              {t("softBannerH")}<span>{t("softBannerSpan")}</span>
            </h1>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb justify-content-center wow fadeInUp delay-0-4s">
                <li className="breadcrumb-item">
                  <Link to="/">
                    {t("softBannerHome")}
                  </Link>
                </li>
                <li
                  className="breadcrumb-item active"
                  style={{ color: "#fff" }}
                >
                  {t("softBannerHomeTitle")}
                </li>
              </ol>
            </nav>
            <div className="banner-btn mt-4 wow fadeInUp delay-0-6s">
              <button
                className="theme-btn"
                onClick={() => setIsModalOpen(true)}
              >
                Book a Demo
              </button>
            </div>
          </div>
        </div>
        <div className="banner-shapes">
          <div
            className="circle softwarecircle wow zoomInLeft delay-0-2s"
            data-wow-duration="2s"
          />
          <img
            className="shape-one"
            src="/images/shapes/hero-shape1.png"
            alt="Shape"
            loading="lazy"
          />
          <img
            className="shape-two"
            src="/images/shapes/hero-shape2.png"
            alt="Shape"
            loading="lazy"
          />
        </div>
      </section>
      {/* Statistics Five Area Start */}
      <section className="statistics-area-five py-130">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-lg-6">
              <div className="statistics-five-content mb-30 rmb-65 wow fadeInRight delay-0-2s">
                <div className="section-title mb-25">
                  <span className="sub-title softwareHEad style-two mb-15">
                    {t("softCompanyH")}
                  </span>
                  <h2>
                    {t("softCompanySub")}
                  </h2>
                </div>
                <p>
                  {t("softCompanyPara")}
                </p>
                <Link to="/contact-us" className="theme-btn softwareLearn style-two mt-15">

                  {t("learnMoreBtn")} <i className="fas fa-angle-double-right" />

                </Link>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="statistics-five-image wow fadeInLeft delay-0-2s">
                <img
                  src="/assets/4 Soft/Group 12.webp"
                  alt="Statistics"
                  loading="lazy"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Statistics Five Area end */}
      {/* Working Process Area start */}
      <section
        className="work-process-area pb-95 rel z-1"
        style={{ overflow: "hidden" }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="section-title text-center mb-55 wow fadeInUp delay-0-2s">
                <span className="sub-title style-two softwareHEad mb-15">
                  {t("softWorkH")}
                </span>
                <h2>{t("softWorkSub")}</h2>
              </div>
            </div>
          </div>
          <div className="work-process-wrap rel z-1">
            <div className="row justify-content-between">
              <div className="col-xl-3 col-lg-5 col-sm-6">
                <div className="work-process-item1 mt-30 wow fadeInUp delay-0-2s">
                  <div className="icon softiconbor">
                    <span className="number">01</span>
                    <i className="flaticon-optimization softicon" />
                  </div>
                  <h4>{t("softwork1H")}</h4>
                  <p>
                    {t("softwork1Para")}</p>
                </div>
              </div>
              <div className="col-xl-3 col-lg-5 col-sm-6">
                <div className="work-process-item1 wow fadeInUp delay-0-4s">
                  <div className="icon softiconbor">
                    <span className="number">02</span>
                    <i className="flaticon-link softicon" />
                  </div>
                  <h4>{t("softwork2H")}</h4>
                  <p>
                    {t("softwork2Para")}
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-lg-5 col-sm-6">
                <div className="work-process-item1 mt-55 wow fadeInUp delay-0-6s">
                  <div className="icon softiconbor">
                    <span className="number">03</span>
                    <i className="flaticon-data softicon" />
                  </div>
                  <h4>{t("softwork3H")}</h4>
                  <p>
                    {t("softwork3Para")}
                  </p>
                </div>
              </div>
              <div className="col-xl-3 col-lg-5 col-sm-6">
                <div className="work-process-item1 mt-45 wow fadeInUp delay-0-8s">
                  <div className="icon softiconbor">
                    <span className="number">04</span>
                    <i className="flaticon-star softicon" />
                  </div>
                  <h4>{t("softwork4H")}</h4>
                  <p>
                    {t("softwork4Para")}
                  </p>
                </div>
              </div>
            </div>
            <div className="work-process-shape">
              <img
                src="/images/shapes/worp-process-step.png"
                alt="Shape"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </section>
      {/* Working Process Area end */}
      {/* Harness Cutting-Edge start*/}
      <section className="call-to-action-area  bgc-black software-bg pt-80 pb-50">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 p-3 d-flex justify-content-center align-items-center">
              <div>
                <h2>
                  {t("softharnessH")}
                </h2>
                <p style={{ color: "#fff" }}>
                  {t("softharnessPara")}
                </p>
                <Link to="/contact-us" className="theme-btn softwareget style-two mt-15">

                  {t("softHarnessschBtn")}{" "}
                  <i className="fas fa-angle-double-right" />

                </Link>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 p-3">
              <div className="row">
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "#c1a184",
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                    }}
                  >
                    <div>
                      <i
                        className="fi fi-ts-source-data"
                        style={{ color: "#fff", fontSize: "30px" }}
                      />
                    </div>
                  </div>
                  <h4>{t("softHarright1H")}</h4>
                  <p style={{ color: "#fff" }}>
                    {t("softHarright1Para")}
                  </p>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "#c1a184",
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                    }}
                  >
                    <div>
                      <i
                        className="fi fi-tr-plan"
                        style={{ color: "#fff", fontSize: "30px" }}
                      />
                    </div>
                  </div>
                  <h4>{t("softHarright2H")}</h4>
                  <p style={{ color: "#fff" }}>
                    {t("softHarright2Para")}
                  </p>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "#c1a184",
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                    }}
                  >
                    <div>
                      <i
                        className="fi fi-tr-cloud-share"
                        style={{ color: "#fff", fontSize: "30px" }}
                      />
                    </div>
                  </div>
                  <h4>{t("softHarright3H")}</h4>
                  <p style={{ color: "#fff" }}>
                    {t("softHarright3Para")}
                  </p>
                </div>
                <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6">
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{
                      backgroundColor: "#c1a184",
                      width: "60px",
                      height: "60px",
                      borderRadius: "50%",
                    }}
                  >
                    <div>
                      <i
                        className="fi fi-tr-customize"
                        style={{ color: "#fff", fontSize: "30px" }}
                      />
                    </div>
                  </div>
                  <h4>{t("softHarright4H")}</h4>
                  <p style={{ color: "#fff" }}>
                    {t("softHarright4Para")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Harness Cutting-Edge end*/}
      {/*Curious whether start*/}
      <section className="call-to-action-area pt-80 pb-50">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 ">
              <div>
                <h2>
                  {t("softCurH1")}{" "}
                  <span className="softwareHEad"> {t("softCurSpan")}</span> {t("softCurH2")}
                </h2>
                <h3>{t("softCurSub")}</h3>
                <p>
                  {t("softCurPara1")}
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <p>
                {t("softCurPara2")}
              </p>
              <form
                onSubmit={handleContact}
                id="contact-area-form"
                className="contact-area-form text-center wow fadeInRight delay-0-2s"
                name="contact-area-form"
                action="#"
                method="post"
              >
                <h4 className="softwareHEad">{t("softFormH")}</h4>
                <input
                  type="text"
                  id="full-name"
                  name="full-name"
                  className="form-control"
                  defaultValue=""
                  placeholder={`${t("softFullName")}`}
                  required
                  onChange={(e) => setData({ ...data, name: e.target.value })}
                />
                <input
                  type="email"
                  id="blog-email"
                  name="blog-email"
                  className="form-control"
                  defaultValue=""
                  placeholder={`${t("softemail")}`}
                  required
                  onChange={(e) => setData({ ...data, mail: e.target.value })}
                />
                <input
                  type="text"
                  id="website"
                  name="website"
                  className="form-control"
                  defaultValue=""
                  placeholder={`${t("softSubject")}`}
                  required
                  onChange={(e) =>
                    setData({ ...data, subject: e.target.value })
                  }
                />
                <textarea
                  name="message"
                  id="message"
                  className="form-control"
                  rows={5}
                  placeholder={`${t("softMeg")}`}
                  required
                  onChange={(e) =>
                    setData({ ...data, message: e.target.value })
                  }
                  defaultValue={""}
                />
                <button type="submit" className="theme-btn2 ">
                  {t("softSendBtn")} <i className="fas fa-angle-double-right" />
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      {/*Curious whether end*/}
      {/* Call to Action start */}
      <section className="call-to-action-area mt-100 bgc-black software-bg pt-80 pb-50">
        <div className="container">
          <div className="row justify-content-between align-items-center">
            <div className="col-xl-7 col-lg-9">
              <div className="section-title text-white mb-25 wow fadeInUp delay-0-2s">
                <h2>{t("softLetsH")}</h2>
                <p>
                  {t("softLetsPara")}
                </p>
              </div>
            </div>
            <div className="col-lg-3 text-lg-end">
              <Link to="/contact-us" className="theme-btn softwareget style-two mb-30 wow fadeInUp delay-0-4s">

                {t("softLetsBtn")} <i className="fas fa-angle-double-right" />

              </Link>
            </div>
          </div>
        </div>
      </section>
      {isModalOpen && (
        <div
          className="book-demo-overlay"
          onClick={(e) => e.target === e.currentTarget && setIsModalOpen(false)}
        >
          <div className="book-demo-modal">
            <div className="book-demo-header">
              <div>
                <h2>Book a Demo</h2>
                <p>Fill in your details and we'll get back to you within 24 hours.</p>
              </div>
              <button
                className="book-demo-close"
                onClick={() => setIsModalOpen(false)}
                aria-label="Close"
              >
                &times;
              </button>
            </div>

            <div className="book-demo-body">
              <div className="book-demo-row">
                <div className="book-demo-group">
                  <label>First Name</label>
                  <input
                    type="text"
                    placeholder="John"
                    value={demoData.firstName}
                    onChange={(e) =>
                      setDemoData({ ...demoData, firstName: e.target.value })
                    }
                  />
                </div>
                <div className="book-demo-group">
                  <label>Last Name</label>
                  <input
                    type="text"
                    placeholder="Doe"
                    value={demoData.lastName}
                    onChange={(e) =>
                      setDemoData({ ...demoData, lastName: e.target.value })
                    }
                  />
                </div>
              </div>

              <div className="book-demo-group">
                <label>Work Email</label>
                <input
                  type="email"
                  placeholder="john@company.com"
                  value={demoData.email}
                  onChange={(e) =>
                    setDemoData({ ...demoData, email: e.target.value })
                  }
                />
              </div>

              <div className="book-demo-group">
                <label>Phone Number</label>
                <input
                  type="tel"
                  placeholder="+1 (555) 000-0000"
                  value={demoData.phone}
                  onChange={(e) =>
                    setDemoData({ ...demoData, phone: e.target.value })
                  }
                />
              </div>

              {/* <div className="book-demo-group">
                <label>Company Name</label>
                <input type="text" placeholder="Acme Inc." />
              </div> */}

              <div className="book-demo-group">
                <label>Service Interested In</label>
                <select
                  value={demoData.service}
                  onChange={(e) =>
                    setDemoData({ ...demoData, service: e.target.value })
                  }
                >
                  <option value="" disabled>Select a service</option>
                  <option>Web Design</option>
                  <option>Web Development</option>
                  <option>SEO &amp; Marketing</option>
                  <option>Other</option>
                </select>
              </div>

              <div className="book-demo-group">
                <label>Message (Optional)</label>
                <textarea
                  placeholder="Tell us about your project..."
                  rows={3}
                  value={demoData.message}
                  onChange={(e) =>
                    setDemoData({ ...demoData, message: e.target.value })
                  }
                />
              </div>

              <button
                className="theme-btn w-100 mt-10"
                onClick={handleBookDemo}
                disabled={isDemoSubmitting}
              >
                {isDemoSubmitting ? "Sending..." : "Schedule Demo"}
              </button>
            </div>
          </div>
        </div>
      )}
      <Footer />
    </>
  );
};

export default SoftwareDevelop;
